<dialog-header
  [title]="'Give Stamps/Points'"
  (onClose)="matDialogRef.close()"
></dialog-header>

<div
  mat-dialog-content
  style="
    padding-bottom: 20px;
    border-top: 1px solid lightgray;
    border-bottom: 1px solid lightgray;
    background-color: var(--app-container);
  "
>
  <form
    [formGroup]="form"
    (ngSubmit)="primaryTapped()"
    style="margin-top: 20px"
  >
    <!-- Customer Selection (only show if not from customer detail page and no preselected customer) -->
    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="!isFromCustomerDetail && !hasPreselectedCustomer"
    >
      <single-select
        label="Customer"
        [formCtrl]="customerFormControl"
        [options]="customers"
        [inBrackets]="'email'"
        [property]="'name'"
        [showSearch]="true"
        (selected)="onCustomerSelected($event)"
      ></single-select>
    </div>

    <!-- Card Selection (show when customer is selected but not from customer detail page with card) -->
    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="!isFromCustomerDetail && customerFormControl.value"
    >
      <single-select
        label="Card"
        [formCtrl]="cardFormControl"
        [options]="customerCards"
        [property]="'cardTitle'"
        [inBrackets]="'info'"
        [showSearch]="false"
        (selected)="onCardSelected($event)"
      ></single-select>
    </div>

    <!-- Stamps/Points Input -->
    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="cardFormControl.value && isStampCard"
    >
      <single-select
        label="Stamps"
        [formCtrl]="stampsFormControl"
        [options]="stampOptions"
        [property]="'number'"
        [showSearch]="false"
      ></single-select>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="cardFormControl.value && !isStampCard"
    >
      <div class="form-field-label">Points</div>
      <input
        class="form-input"
        autocomplete="off"
        [maxlength]="5"
        [formControl]="pointsFormControl"
        type="number"
        placeholder="Enter number of points"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
      />
    </div>

    <!-- Location Selection -->
    <div
      class="form-field"
      style="margin-top: 20px"
      *ngIf="locations.length > 1"
    >
      <single-select
        label="Location"
        [formCtrl]="locationFormControl"
        [options]="locations"
        [inBrackets]="'formattedAddress'"
        [property]="'name'"
        [showSearch]="false"
      ></single-select>
    </div>

    <div
      class="form-field"
      style="margin-top: 20px; display: flex; justify-content: space-between"
      *ngIf="cardFormControl.value"
    >
      <div class="form-field-label">Notify customer via push notification</div>
      <mat-slide-toggle
        [disabled]="false"
        [checked]="notify"
        (change)="notify = !notify"
      >
      </mat-slide-toggle>
    </div>

    <app-info-box
      *ngIf="cardFormControl.value && notify"
      [title]="'Notification Preview'"
      [body]="getNotificationPreview()"
      [canDismiss]="false"
    ></app-info-box>
  </form>
</div>

<div mat-dialog-actions align="end">
  <app-secondary-button
    style="margin-right: 10px"
    [title]="'Cancel'"
    [disabled]="false"
    (tapped)="matDialogRef.close()"
  ></app-secondary-button>

  <app-primary-button
    [title]="'Give ' + (isStampCard ? 'Stamps' : 'Points')"
    [disabled]="!canSubmit()"
    (tapped)="primaryTapped()"
    bgColor="var(--app-timber)"
    color="white"
  ></app-primary-button>
</div>

<loader
  [loading]="loading || locationsLoading || customersLoading || cardsLoading"
></loader>
